let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3qbPb")).then(() => parcelRequire('7cegm'));